import axios from "axios";
import config from "@config";
import { queryStringToObject, getAuthorizationToken, deleteAuthorizationToken } from "@utils/utilities";

const apiService = (baseURL) => {
  const axiosInstance = axios.create({
    baseURL,
    withCredentials: true,
  });

  axiosInstance.interceptors.request.use(
    (request) => requestHandler(request),
    (error) => errorHandler(error)
  );

  axiosInstance.interceptors.response.use(
    (response) => responseHandler(response),
    (error) => errorHandler(error)
  );

  return axiosInstance;
};

const requestHandler = (request) => {
  const token = getAuthorizationToken(config.GENIE_ACCESS_CODE);
  request.headers.Authorization = token ? `Bearer ${token}` : "";
  request.headers["Cache-Control"] = "no-cache";
  return request;
};

const responseHandler = (response) => {
  return response;
};

const errorHandler = (error) => {
  requestInterceptorsHandler(error);
  return Promise.reject(error);
};

const requestInterceptorsHandler = (res) => {
  const origin = window.location.origin;
  const { response = {} } = res;
  if (response?.status === 401 || response?.data?.systemMessage?.code === 401) {
    const { login = false } = queryStringToObject(window?.location?.search);
    if (!login) {
      let HOST = response?.data?.data?.host || "";
      if (origin.indexOf(config.APP_LOCAL_PATH) !== -1) {
        HOST = `${config.GENIE_AUTH_URL}?TARGET=`;
      }

      HOST = HOST + encodeURIComponent(window.location.href);

      deleteAuthorizationToken(config.GENIE_ACCESS_CODE);
      window.location.replace(HOST);
    }
  }
};

export default apiService;
